import React, { useMemo, useState, useEffect, useContext } from "react";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import { StyledTablePage } from "../../styled-components/StyledTablePage.style";
import TimeSheetDetalhesContext from "../../contexts/TimeSheetDetalhesContext";

import api from '../../services/api';
import { useLocation } from "react-router-dom";

export const ModalTimesheetResumo = ({ isOpen, onAfterOpen, onRequestClose, resumo, timesheet, resumoAtividades, isFromProjetoInterno }) => {
  const {timesheetDetails} = useContext(TimeSheetDetalhesContext);

  let location = useLocation();
  const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
  }
  
  const style = {
      content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          borderRadius: "0px",
          minWidth: '35%',
          overflowY: 'auto',
          minHeight: '45%',
          maxHeight: '90%',
          maxWidth: '100%'
      },
        overlay: {
            zIndex: 9999
        }
  };

  const colunas = useMemo(() => [{
    columns: [
      {
        Header: "Profissional"
      },
      {
        Header: "Laudo"
      },
      {
        Header: "TimeSheet"
      },
      {
        Header: "Horas"
      },
      {
        Header: "Valor"
      },
      {
        Header: "%"
      }]
    }],
  []);

  const colunas_pi = useMemo(() => [{
    columns: [
      {
        Header: "Profissional"
      },
      {
        Header: "Laudo"
      },
      {
        Header: "TimeSheet"
      },
      {
        Header: "Horas"
      }]
    }],
  []);

  const colunas_atividades = useMemo(() => [{
      columns: [
        {
          Header: "Atividade"
        },
        {
          Header: "Laudo"
        },
        {
          Header: "TimeSheet"
        },
        {
          Header: "Horas"
        },
        {
          Header: "Valor"
        },
        {
          Header: "%"
        }]
      }],
  []);

  const colunas_atividades_pi = useMemo(() => [{
    columns: [
      {
        Header: "Atividade"
      },
      {
        Header: "Laudo"
      },
      {
        Header: "TimeSheet"
      },
      {
        Header: "Horas"
      }]
    }],
  []);

  const atividadesSemTotal = resumoAtividades
  ?.filter(f => f.totalValorFaturado !== "R$ 0,00" && f.idAtividade !== -1)
  .sort((a, b) => {
    const valorA = parseFloat(a.totalValorFaturado.replace("R$ ", "").replace(/\./g, "").replace(",", "."));
    const valorB = parseFloat(b.totalValorFaturado.replace("R$ ", "").replace(/\./g, "").replace(",", "."));
    return valorB - valorA;
  });

  const atividadeTotal = resumoAtividades?.find(f => f.idAtividade === -1);
  const atividadesParaExibir = [...atividadesSemTotal, ...(atividadeTotal ? [atividadeTotal] : [])];

  const atividadesSemTotalHoras = resumoAtividades
  ?.filter(f => f.totalHoras !== "0,00" && f.idAtividade !== -1)
  .sort((a, b) => {
    const horasA = parseFloat(a.totalHoras.replace(/\./g, "").replace(",", "."));
    const horasB = parseFloat(b.totalHoras.replace(/\./g, "").replace(",", "."));
    return horasB - horasA;
  });

  const atividadeTotalHoras = resumoAtividades?.find(f => f.idAtividade === -1);
  const atividadesParaExibirHoras = [...atividadesSemTotalHoras, ...(atividadeTotalHoras ? [atividadeTotalHoras] : [])];

  const totalGeralFaturado = atividadesParaExibir
  .filter(a => a.idAtividade !== -1)
  .reduce((acc, curr) => {
    const valor = parseFloat(curr.totalValorFaturado.replace("R$ ", "").replace(/\./g, "").replace(",", "."));
    return acc + (isNaN(valor) ? 0 : valor);
  }, 0);

  return (
    <Modal
        isOpen={isOpen}
        onAfterOpen={onAfterOpen}
        onRequestClose={onRequestClose}
        contentLabel="Timesheet Atividades"
        style={style}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={false}
    >
      <StyledForm>
        <p className="modal-close" onClick={onRequestClose}>X</p>
      </StyledForm>                       
      <Flex>
          <StyledForm style={{width: "100%"}}>
              <Flex>
                  <Flex.Item className="modal-width">
                      <div className="position-relative form-group">                  
                          <p className="modal-title">Resumo Profissionais</p>                                                        
                      </div>
                  </Flex.Item>
              </Flex>                             
              <StyledTablePage>
                  <table className="table table-bordered table-width">
                      <thead>
                          <tr className="table-legend-info">
                          {
                            !isFromProjetoInterno ? 
                              colunas[0].columns.map(column => (
                                <th key={column.Header}>{column.Header}</th>
                                ))
                            :
                              colunas_pi[0].columns.map(column => (
                                <th key={column.Header}>{column.Header}</th>
                                ))
                          }
                          </tr>
                      </thead>
                      <tbody>
                      {
                        isFromProjetoInterno ? 
                          resumo
                            ?.slice()
                            .sort((a, b) => {
                              if (a.idUsuarioPerito === -1) return 1; // total vai pro fim
                              if (b.idUsuarioPerito === -1) return -1;

                              const horasA = parseFloat(a.totalHorasFaturadas.toString().replace(",", "."));
                              const horasB = parseFloat(b.totalHorasFaturadas.toString().replace(",", "."));

                              return horasB - horasA; // ordem decrescente
                            })
                            .map(profissional => (
                              <tr 
                                key={profissional.idUsuarioPerito} 
                                className={`table-data-info ${profissional.idUsuarioPerito == -1 ? 'tableFooter' : ''}`}
                              >
                                <td>{profissional.nome}</td>
                                <td>{profissional.laudo}</td>
                                <td>{profissional.timesheet}</td>
                                <td>{profissional.totalHorasFaturadas}</td>
                              </tr>
                          ))
                        :
                        resumo
                        ?.slice()
                        .sort((a, b) => {
                          if (a.idUsuarioPerito === -1) return 1;
                          if (b.idUsuarioPerito === -1) return -1;
                      
                          const valorA = parseFloat(a.totalValortotalexecutado.toString().replace("R$ ", "").replace(/\./g, "").replace(",", "."));
                          const valorB = parseFloat(b.totalValortotalexecutado.toString().replace("R$ ", "").replace(/\./g, "").replace(",", "."));
                      
                          return valorB - valorA;
                        })
                        .map(profissional => {
                          const totalGeral = resumo.find(p => p.idUsuarioPerito === -1);
                          const totalGeralValor = totalGeral
                            ? parseFloat(totalGeral.totalValortotalexecutado.toString().replace("R$ ", "").replace(/\./g, "").replace(",", "."))
                            : 0;
                      
                          const valorIndividual = parseFloat(profissional.totalValortotalexecutado.toString().replace("R$ ", "").replace(/\./g, "").replace(",", "."));
                      
                          let proporcao = '';
                          if (profissional.idUsuarioPerito !== -1 && totalGeralValor > 0) {
                            proporcao = ((valorIndividual / totalGeralValor) * 100).toFixed(2).replace('.', ',') + '%';
                          }
                      
                          return (
                            <tr 
                              key={profissional.idUsuarioPerito} 
                              className={`table-data-info ${profissional.idUsuarioPerito == -1 ? 'tableFooter' : ''}`}
                            >
                              <td>{profissional.nome}</td>
                              <td>{profissional.laudo}</td>
                              <td>{profissional.timesheet}</td>
                              <td>{profissional.totalHorasFaturadas}</td>
                              <td>{profissional.totalValortotalexecutado}</td>
                              <td>{proporcao}</td>
                            </tr>
                          );
                        })
                        }
                      </tbody>
                  </table>
              </StyledTablePage>

              <Flex>
                  <Flex.Item className="modal-width">
                      <div className="position-relative form-group">                  
                          <p className="modal-title">Resumo Atividades</p>                                                        
                      </div>
                  </Flex.Item>
              </Flex> 
              <StyledTablePage>
                  <table className="table table-bordered table-width">
                      <thead>
                          <tr className="table-legend-info">
                          {
                            !isFromProjetoInterno ? 
                            colunas_atividades[0].columns.map(column => (
                              <th key={column.Header}>{column.Header}</th>
                              ))
                            :
                            colunas_atividades_pi[0].columns.map(column => (
                              <th key={column.Header}>{column.Header}</th>
                              ))
                          }
                          </tr>
                      </thead>
                      <tbody>
                        {
                          !isFromProjetoInterno ?   
                                                 
                          atividadesParaExibir.map((atividade, index) => {
                            const valorIndividual = parseFloat(atividade.totalValorFaturado.replace("R$ ", "").replace(/\./g, "").replace(",", "."));
                            const percentual = totalGeralFaturado && atividade.idAtividade !== -1
                              ? ((valorIndividual / totalGeralFaturado) * 100).toFixed(2)
                              : "";

                            return (
                              <tr key={index} className={`table-data-info ${atividade.idAtividade == -1 ? 'tableFooter' : ''}`}>
                                <td>
                                  {atividade.atividade && atividade.atividade.length > 80
                                    ? atividade.atividade.substring(0, 80) + " ..."
                                    : atividade.atividade}
                                </td>
                                <td>{atividade.laudo}</td>
                                <td>{atividade.timesheet}</td>
                                <td>{atividade.totalHoras}</td>
                                <td>{atividade.totalValorFaturado}</td>
                                <td>{atividade.idAtividade === -1 ? '' : `${percentual}%`}</td>
                              </tr>
                            );
                          })
                          :
                          atividadesParaExibirHoras.map((atividade, index) => (
                              <tr key={index} className={`table-data-info ${atividade.idAtividade == -1 ? 'tableFooter' : ''}`}>
                                  <td>
                                    {atividade.atividade && atividade.atividade.length > 80
                                      ? atividade.atividade.substring(0, 80) + " ..."
                                      : atividade.atividade}
                                  </td>
                                  <td>{atividade.laudo}</td>
                                  <td>{atividade.timesheet}</td>
                                  <td>{atividade.totalHoras}</td>
                              </tr>
                          ))
                        }
                      </tbody>
                  </table>
              </StyledTablePage>
          </StyledForm>
      </Flex>                            
    </Modal>
  );
};